var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 19,
  height: 27,
  viewBox: "0 0 19 27"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_20776",
  "data-name": "Rectangle 20776",
  width: 5.195,
  height: 2.65,
  fill: "none"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "engine-on-recording_",
  "data-name": "engine-on-recording ",
  transform: "translate(3081 3916)"
}, /*#__PURE__*/React.createElement("g", {
  id: "engine-on-recording",
  transform: "translate(31 40)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_31628",
  "data-name": "Group 31628",
  transform: "translate(-3108 -3956)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_31631",
  "data-name": "Group 31631"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_44147",
  "data-name": "Path 44147",
  d: "M15,8.806c-.2.212-.395.429-.6.631a.358.358,0,0,1-.219.059c-.195.008-.39,0-.586,0-.256,0-.343-.089-.344-.343,0-.493,0-.985,0-1.478v-.17h-.5V7.67q0,1,0,1.99c0,.251-.083.337-.331.338q-3.544,0-7.087,0a.368.368,0,0,1-.338-.186c-.263-.4-.536-.8-.8-1.207a.22.22,0,0,0-.214-.113c-.366.005-.732,0-1.1,0-.31,0-.382-.071-.382-.377,0-.448,0-.9,0-1.357H2V6.92c0,.415,0,.829,0,1.244,0,.252-.08.33-.334.332s-.537,0-.805,0S.5,8.417.5,8.142C.5,7.5.5,6.854.5,6.21a.525.525,0,0,0-.079-.254C.285,5.74.14,5.532,0,5.321V4.414c.168-.249.339-.5.5-.749a.325.325,0,0,1,.3-.164c.3.006.6,0,.893,0,.206,0,.295.089.3.294,0,.424,0,.849,0,1.273,0,.053,0,.105,0,.168H2.49c0-.052.008-.1.008-.154q0-.593,0-1.186c0-.333.063-.4.389-.4.366,0,.732,0,1.1,0a.207.207,0,0,0,.2-.106c.253-.388.52-.767.765-1.16A.459.459,0,0,1,5.409,2c.385.014.771,0,1.157,0h.171V1.5H6.573c-.493,0-.986,0-1.479,0-.259,0-.344-.086-.345-.341q0-.41,0-.82c0-.253.089-.341.346-.341H9.914c.247,0,.337.091.338.334q0,.41,0,.82c0,.263-.084.347-.354.347-.483,0-.967,0-1.45,0H8.263V2h.165c.386,0,.772.01,1.157,0a.468.468,0,0,1,.468.246c.241.39.507.764.756,1.148a.219.219,0,0,0,.213.112c.469-.005.937,0,1.406,0,.235,0,.318.083.319.316,0,.551,0,1.1,0,1.666h.5v-.37c0-.259,0-.517,0-.776S13.334,4,13.58,4c.21,0,.42-.006.63,0a.349.349,0,0,1,.213.074c.2.192.386.4.577.6ZM3.008,8c.39,0,.77,0,1.15,0a.374.374,0,0,1,.352.187c.259.4.531.795.79,1.2a.244.244,0,0,0,.238.124q2.768,0,5.536,0h.165V4C11.1,4,10.964,4,10.833,4a.35.35,0,0,1-.339-.182c-.263-.4-.535-.8-.8-1.208A.222.222,0,0,0,9.483,2.5q-1.985,0-3.969,0a.222.222,0,0,0-.211.117c-.261.4-.532.794-.791,1.2A.381.381,0,0,1,4.148,4c-.332-.008-.664,0-1,0-.047,0-.094,0-.143.008Zm10.749.988c.221.032.426.051.568-.162.027-.04.076-.065.1-.105A.386.386,0,0,0,14.5,8.54q.006-1.791,0-3.583a.2.2,0,0,0-.025-.123c-.186-.214-.37-.442-.718-.307Zm-2,.506h.481V4.009H11.76ZM1.486,7.991V4.007c-.038,0-.067,0-.1,0A1.175,1.175,0,0,0,.9,4.022c-.13.068-.193.259-.293.39a.619.619,0,0,0-.114.349.966.966,0,0,0,.231.754,1.294,1.294,0,0,1,.185.28.7.7,0,0,1,.085.284C1,6.664,1,7.249,1,7.833v.158Zm3.767-7H9.744V.512H5.253Zm7.5,5.993h.478V6h-.478ZM7.742,1.512h-.48v.48h.48ZM2.011,6.241h.475V5.756H2.011Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_31633",
  "data-name": "Group 31633",
  transform: "translate(4.825 5.16)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_31632",
  "data-name": "Group 31632",
  transform: "translate(0 0)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_44169",
  "data-name": "Path 44169",
  d: "M.671,2.483A1.255,1.255,0,0,1,.18,2.016,1.313,1.313,0,0,1,0,1.327,1.322,1.322,0,0,1,.18.636,1.251,1.251,0,0,1,.671.167,1.446,1.446,0,0,1,1.367,0,1.438,1.438,0,0,1,2.06.167a1.238,1.238,0,0,1,.489.469,1.333,1.333,0,0,1,.178.691,1.323,1.323,0,0,1-.178.689,1.242,1.242,0,0,1-.489.467,1.438,1.438,0,0,1-.693.167,1.446,1.446,0,0,1-.7-.167M1.72,1.96a.649.649,0,0,0,.254-.251.749.749,0,0,0,.095-.382.751.751,0,0,0-.093-.38A.653.653,0,0,0,1.723.7.72.72,0,0,0,1.367.607.727.727,0,0,0,1.007.7.653.653,0,0,0,.754.947a.751.751,0,0,0-.093.38.761.761,0,0,0,.093.382.634.634,0,0,0,.254.251.742.742,0,0,0,.358.087A.724.724,0,0,0,1.72,1.96",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_44170",
  "data-name": "Path 44170",
  d: "M9.84.18h.636l.934,1.512V.18h.643V2.721h-.633L10.483,1.2V2.721H9.84Z",
  transform: "translate(-6.859 -0.125)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "e0ad44c8f4fc2269890a34dd1b32f616",
  transform: "translate(-3085 -3906)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_44176",
  "data-name": "Path 44176",
  d: "M13.75,6.2V5a3.009,3.009,0,0,0-3-3H7A3.009,3.009,0,0,0,4,5v9a3.009,3.009,0,0,0,3,3h6a3.009,3.009,0,0,0,3-3V8.75a.681.681,0,0,0-.225-.525ZM14.5,14A1.5,1.5,0,0,1,13,15.5H7A1.5,1.5,0,0,1,5.5,14V5A1.5,1.5,0,0,1,7,3.5h3.75A1.5,1.5,0,0,1,12.25,5V6.5a.681.681,0,0,0,.225.525L14.5,9.05Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_44177",
  "data-name": "Path 44177",
  d: "M7.75,5A.709.709,0,0,0,7,5.75V6.5a.709.709,0,0,0,.75.75A.709.709,0,0,0,8.5,6.5V5.75A.709.709,0,0,0,7.75,5ZM10,5a.709.709,0,0,0-.75.75V6.5a.75.75,0,0,0,1.5,0V5.75A.709.709,0,0,0,10,5Z",
  transform: "translate(-0.75 -0.75)"
})))));

export default __webpack_public_path__ + "static/media/engine-on-recording.6a388e37.svg";
export { SvgComponent as ReactComponent };